import * as THREE from 'three';
// import * as Sentry from '@sentry/react';
import {
  greaterOrEqual,
  lessOrEqual,
  nearlyEqual,
  roundLeft,
  roundTo,
} from '../../../../utils/geometry/epsilon';
import BaseNesting from './BaseNesting';
import {
  DoorDirection,
  HorizontalType,
  InsideType,
  ModuleType,
} from '../../../../constants/enum';
import { GeometryUtils } from '../../../../utils/geometry/GeometryUtils';
import { clearVisual, ItemRetangle, MaxRectsPacker } from './Packing';
import {
  closeNotification,
  openNotification,
} from '../../../../components/common/Notification/openNotification';
import { Icon } from '../../../../components/icon/icon';
import i18n from '../../../../languages/i18n';
import { getValueFromString } from '../../../../utils/data/getValue.utils';

import PricingAdapter from '../../../../services/pricing/PricingAdapter';

// import callApi from '../../../../utils/api/callAPI';
// import { openMessageError } from '../../../../components/common/Message/openMessageError';

class NestingController extends BaseNesting {
  constructor({ cabinetManager }) {
    super({ cabinetManager });
    this.pricingAdapterVN = new PricingAdapter({});
    this.pricingAdapterUS = new PricingAdapter({});

    this.widthCabinetTrim = 0.03; // Kích thước rộng nẹp
    this.heightCabinetTrim = 0.03; // Kích thước cao nẹp

    // this.fetchJSON();

    this.clearData();
  }

  updateDefaultViPriceConfig({ priceConfig, profitConfig, ruleConfig }) {
    this.pricingAdapterVN = new PricingAdapter({
      ruleConfig: ruleConfig.pro ?? ruleConfig,
      priceConfig: priceConfig.pro ?? priceConfig,
      profitConfig: profitConfig.pro ?? profitConfig,
    });
    this.clearData();
    console.log('Master default VI configs have updated!!!');
  }

  updateDefaultUsPriceConfig({ priceConfig, profitConfig, ruleConfig }) {
    this.pricingAdapterUS = new PricingAdapter({
      ruleConfig: ruleConfig.pro ?? ruleConfig,
      priceConfig: priceConfig.pro ?? priceConfig,
      profitConfig: profitConfig.pro ?? profitConfig,
    });
    this.clearData();
    console.log('Master default US configs have updated!!!');
  }
  // async fetchJSON() {
  //   try {
  //     const res = await callApi({
  //       endpoint: 'products/v3/products/default_setting',
  //       method: 'GET',
  //     });
  //     const raw = res.data;
  //     const result = raw.result;
  //     const data = result.data;
  //     const price = data.price;
  //     const profit = data.profit;
  //     const rule = data.rule;

  //     if (!price || !profit || !rule) {
  //       throw new Error('Faild to load config price');
  //     }

  //     this.pricingAdapter = new PricingAdapter(rule, price, profit);
  //     this.clearData();
  //   } catch (error) {
  //     openMessageError({
  //       content: error?.message ?? 'Faild to load config price',
  //     });
  //   }
  // }

  THICKNESS_17 = 0.017;
  THICKNESS_08 = 0.008;
  BOARD_WIDTH = 2.44; // in meters
  BOARD_HEIGHT = 1.22; // in meters

  // FIXED [C1]: Safe formula evaluator to replace eval()
  // safeEvaluateFormula = (formula, variables = {}) => {
  //   const allowedPattern = /^[\d+\-*/(). ]+$/;
  //   if (!allowedPattern.test(formula)) {
  //     throw new Error(`Invalid formula: contains disallowed characters`);
  //   }
  //   const keys = Object.keys(variables??{});
  //   const values = Object.values(variables??{});
  //   const func = new Function(...keys, `return ${formula}`);
  //   return func(...values);
  // };

  updateCabinetTrimSettings(newCbTrim) {
    this.widthCabinetTrim = newCbTrim.width;
    this.heightCabinetTrim = newCbTrim.height;

    super.updateCabinetTrimSettings(newCbTrim);
  }

  clearData = () => {
    this.pricingAdapterVN.clearCosts();
    this.pricingAdapterUS.clearCosts();

    this.doorsData = [];
    this.materialsData = [
      { type: 'edgeBanding', subtype: 'normal', quantity: 0, unit: 'm' },
      { type: 'edgeBanding', subtype: 'diff', quantity: 0, unit: 'm' },
      { type: 'edgeBanding', subtype: 'bevel', quantity: 0, unit: 'm' },
    ];
    this.componentsData = [
      { type: 'hinges', quantity: 0, unit: 'pcs' },
      { type: 'hinges135', quantity: 0, unit: 'pcs' },
      { type: 'connectors', quantity: 0, unit: 'pcs' },
      { type: 'rails', quantity: 0, unit: 'pcs' },
    ];
    this.accessoriesData = [
      // { type: 'leds', quantity: 0 },
      // { type: 'ledsDecor', quantity: 0 },
      { type: 'lightSwitches', quantity: 0, unit: 'pcs' },
      { type: 'ledDrivers', quantity: 0, unit: 'pcs' },
      // { type: 'standardLock', quantity: 0, unit: 'pcs' },
      // { type: 'clothesHangers', quantity: 0 },
      // { type: 'mirrors', quantity: 0 },
    ];
    this.specialsData = [
      // { type: 'countertops', quantity: 0 },
      // { type: 'backsplash', quantity: 0 },
      // { type: 'curveBlocks', subtype: 'rank1', quantity: 0 },
      // { type: 'curveBlocks', subtype: 'rank2', quantity: 0 },
      // { type: 'curveBlocks', subtype: 'rank3', quantity: 0 },
      // { type: 'acrylicCabinetTrims', quantity: 0 },
    ];
    this.shippingForeignData = [
      { type: 'shippingFee' },
      { type: 'groundTripFee' },
      // { type: 'curveBlocks', subtype: 'rank2', quantity: 0 },
      // { type: 'curveBlocks', subtype: 'rank3', quantity: 0 },
      // { type: 'acrylicCabinetTrims', quantity: 0 },
    ];
    this.laborsData = [
      { type: 'design', quantity: 0, unit: 'sheet' },
      { type: 'cnc', quantity: 0, unit: 'sheet' },
      { type: 'edgeBanding', subtype: 'normal', quantity: 0, unit: 'm' },
      { type: 'edgeBanding', subtype: 'diff', quantity: 0, unit: 'm' },
      { type: 'edgeBanding', subtype: 'bevel', quantity: 0, unit: 'm' },
      { type: 'packing', quantity: 0, unit: 'sheet' },
      // { type: 'painting', quantity: 0 },
      { type: 'assembly', subtype: 'wardrobe', quantity: 0, unit: 'm²' },
      { type: 'assembly', subtype: 'kitchenLower', quantity: 0, unit: 'm' },
      { type: 'assembly', subtype: 'kitchenUpper', quantity: 0, unit: 'm' },
      { type: 'assembly', subtype: 'kitchenCeiling', quantity: 0, unit: 'm' },
      { type: 'assembly', subtype: 'totl', quantity: 0, unit: 'm²' },
      { type: 'assembly', subtype: 'dry', quantity: 0, unit: 'm²' },
      { type: 'assembly', subtype: 'shoeCabinet', quantity: 0, unit: 'm²' },
      { type: 'assembly', subtype: 'decorative', quantity: 0, unit: 'm²' },
      { type: 'assembly', subtype: 'tv', quantity: 0, unit: 'm' },
      { type: 'assembly', subtype: 'bed', quantity: 0, unit: 'pcs' },
      { type: 'assembly', subtype: 'bedLower', quantity: 0, unit: 'm2' },
      { type: 'assembly', subtype: 'bedDrawer', quantity: 0, unit: 'pcs' },
      { type: 'assembly', subtype: 'desk', quantity: 0, unit: 'm' },
      { type: 'assembly', subtype: 'vanity', quantity: 0, unit: 'm' },
      { type: 'assembly', subtype: 'shelf', quantity: 0, unit: 'm' },
      { type: 'assembly', subtype: 'shoeBench', quantity: 0, unit: 'm2' },
      {
        type: 'assembly',
        subtype: 'slatWallPartition',
        quantity: 0,
        unit: 'm2',
      },
      {
        type: 'assembly',
        subtype: 'wallPanelMelamine',
        quantity: 0,
        unit: 'm2',
      },
      { type: 'assembly', subtype: 'wallPanelMirror', quantity: 0, unit: 'm2' },
      // { type: 'assembly', subtype: 'wallPanelMelamine', quantity: 0 },
      // { type: 'assembly', subtype: 'slatWallPartition', quantity: 0 },
      // { type: 'assembly', subtype: 'wallPanelMirror', quantity: 0 },
      // { type: 'assembly', subtype: 'led', quantity: 0 },
      // { type: 'assembly', subtype: 'platformBed', quantity: 0 },
    ];
    this.parts = [];
    this.oversizeModule = [];
    this.noTexture = false;
    this.noGlass = false;
    this.noAlum = false;
    this.useSpecialTexture = null;
    this.useAcrylic = null;
    this.useAlum = null;

    this.boards = [];
  };

  disassemblyDoorAndHinge = ({ modules }) => {
    Array.from(modules).forEach(([key, value]) => {
      try {
        const moduleType = value.moduleType ?? '';
        if (
          !['curved_block', 'present'].some(type => moduleType.includes(type))
        ) {
          const textures = value.textures;
          const doorTexture = textures.get('DOOR');
          const doorAlumTexture = textures.get('DOOR-ALUM');
          const doorGlass = textures.get('GLASS-PANEL');
          const isPaint = doorTexture?.paintColor !== undefined;

          const noGrain = doorTexture?.no_grain;
          const alumDoor = doorAlumTexture?.material === 'Aluminum';
          const isAcrylic =
            doorTexture?.supplier?.materialType.includes('Acrylic');

          value.group.children.forEach(group => {
            // kiểm tra phần tử này nếu là cửa thì thêm vào danh sách
            if (
              group.isGroup &&
              group.userData.type === InsideType.DOOR &&
              group.userData.isInside
            ) {
              const door = group;

              const box = new THREE.Box3().setFromObject(door);
              const size = box.getSize(new THREE.Vector3());
              const height = size.y;
              const width = Math.max(size.x, size.z);
              let hinge = 0;
              let hinge135 = 0;
              // let rail = 0;
              if (
                !door.userData.drawerUuid &&
                !door.parent?.userData?.drawerUuid
              ) {
                if (door.userData.doorDirection === DoorDirection.HORIZONTAL) {
                  if (['corner'].some(item => moduleType.includes(item))) {
                    hinge135 = this.checkHingeCornerCabinet(width);
                  } else {
                    hinge = this.checkHinge(height, width);
                  }
                } else {
                  if (['corner'].some(item => moduleType.includes(item))) {
                    hinge135 = this.checkHingeCornerCabinet(height);
                  } else {
                    hinge = this.checkHinge(width, height);
                  }
                }
              } else {
                // cửa ngăn kéo không tính bản lề
                // cửa ngăn kéo tính 2 ray
                // rail = 2;
              }

              if (door.userData.horizontalType === HorizontalType.TWO_D) {
                hinge = hinge * 2;
                hinge135 = hinge135 * 2;
              }
              this.componentsData.forEach(component => {
                if (component.type === 'hinges') {
                  component.quantity += hinge;
                } else if (component.type === 'hinges135') {
                  component.quantity += hinge135;
                }
              });
              // this.countHinge += hinge;
              // this.countHinge135 += hinge135;
              // this.countRail += rail;

              const area = roundTo(width * height, 6);
              let priceGlass = 0;
              let pricePaint = 0;
              let priceMelamine = 0;
              let priceAlum = 0;
              let priceAcrylic = 0;

              let priceAlumDoorBonus =
                getValueFromString(doorGlass?.textureCode)
                  ?.toLowerCase()
                  ?.includes('kính sọc') && alumDoor
                  ? this.alumDoorTripedGlassPrice
                  : 0;
              priceAlumDoorBonus += doorAlumTexture?.texturePrice ?? 0;

              const materialType = door.userData.materialType ?? '';
              if (materialType === 'nhom_kinh') {
                if (alumDoor) {
                  this.useAlum = true;
                  this.doorsData.push({
                    type: 'alum',
                    quantity: area,
                    id: doorAlumTexture?.textureId,
                    // textureType: doorAlumTexture?.supplier?.materialType,
                    matetial: doorAlumTexture?.matetial,
                    customPrice: priceAlumDoorBonus,
                    thickness: 0.017,
                    name: `${doorAlumTexture?.textureCode ?? ''}`,
                    unit: 'm²',
                  });
                  /**
                   * 
                          FITTA V1 - BA DOCUMENT 
                          Kính gân sọc trong Đơn giá cộng thêm 
                          300,000đ/m², kính gân sọc màu Đơn giá 
                          cộng thêm 950,000đ/m². Chiều cao cánh 
                          tối đa 2.4m.
                   */
                } else {
                  this.noAlum = true;
                }
              }
              // tính giá kính
              if (
                ['kinh', 'vom'].some(item => materialType.includes(item)) &&
                materialType !== 'nhom_kinh'
              ) {
                // priceGlass = this.getGlassInsideDoorPriceTotal(area);
                if (doorGlass?.texturePrice) {
                  this.doorsData.push({
                    type: 'glassInside',
                    quantity: area,
                    id: doorGlass?.textureId,
                    customPrice: doorGlass?.texturePrice || 0,
                    thickness: doorGlass?.texturePrice?.thickness,
                    name: `${doorGlass?.textureCode ?? ''}`,
                    unit: 'm²',
                  });
                } else {
                  this.noGlass = true;
                }
              }

              if (isAcrylic) {
                this.useAcrylic = true;
                this.doorsData.push({
                  type: 'acrylic',
                  quantity: area,
                  id: doorTexture?.textureId,
                  textureType: doorTexture?.supplier?.materialType,
                  matetial: doorTexture?.matetial,
                  customPrice: doorTexture?.texturePrice?.['0.017'] || 0,
                  thickness: 0.017,
                  name: `${doorTexture?.textureCode ?? ''}`,
                  unit: 'm²',
                });
              }
              if (materialType === 'kinh' || materialType === 'vom') {
                if (isPaint) {
                  this.doorsData.push({
                    type: 'normal',
                    quantity: area,
                    subtype: 'dulux',
                    unit: 'm²',
                  });
                }
              }
              // tính giá sơn cửa pano
              else if (materialType === 'pano') {
                if (noGrain) {
                  if (isPaint) {
                    this.doorsData.push({
                      type: 'noGrainPano',
                      quantity: area,
                      subtype: 'dulux',
                      unit: 'm²',
                    });
                  } else {
                    this.doorsData.push({
                      type: 'noGrainPano',
                      quantity: area,
                      id: doorTexture?.textureId,
                      textureType: doorTexture?.supplier?.materialType,
                      matetial: doorTexture?.matetial,
                      thickness: 0.017,
                      subtype: 'melamine',
                      unit: 'm²',
                    });
                  }
                } else {
                  this.doorsData.push({
                    type: 'grainPano',
                    quantity: area,
                    id: doorTexture?.textureId,
                    textureType: doorTexture?.supplier?.materialType,
                    matetial: doorTexture?.matetial,
                    thickness: 0.017,
                    subtype: 'melamine',
                    unit: 'm²',
                  });
                }
              }
              // tính giá sơn cửa lá sách
              else if (materialType === 'la_sach') {
                if (isPaint) {
                  this.doorsData.push({
                    type: 'louver',
                    quantity: area,
                    subtype: 'dulux',
                    unit: 'm²',
                  });
                } else {
                  this.doorsData.push({
                    type: 'louver',
                    quantity: area,
                    id: doorTexture?.textureId,
                    textureType: doorTexture?.supplier?.materialType,
                    matetial: doorTexture?.matetial,
                    thickness: 0.017,
                    subtype: 'melamine',
                    unit: 'm²',
                  });
                }
              }
              // tính giá sơn cửa phay
              else if (materialType.includes('phay')) {
                if (isPaint) {
                  this.doorsData.push({
                    type: 'milled',
                    quantity: area,
                    subtype: 'dulux',
                    unit: 'm²',
                  });
                } else {
                  this.doorsData.push({
                    type: 'milled',
                    quantity: area,
                    subtype: 'melamine',
                    id: doorTexture?.textureId,
                    textureType: doorTexture?.supplier?.materialType,
                    matetial: doorTexture?.matetial,
                    thickness: 0.017,
                    unit: 'm²',
                  });
                }
              }
              // tính giá sơn cửa đục lỗ tương tự cửa phay
              else if (materialType.includes('duc_lo')) {
                if (isPaint) {
                  this.doorsData.push({
                    type: 'drilled',
                    quantity: area,
                    subtype: 'dulux',
                    unit: 'm²',
                  });
                } else {
                  this.doorsData.push({
                    type: 'drilled',
                    quantity: area,
                    subtype: 'melamine',
                    id: doorTexture?.textureId,
                    textureType: doorTexture?.supplier?.materialType,
                    matetial: doorTexture?.matetial,
                    thickness: 0.017,
                    unit: 'm²',
                  });
                }
              }
              // tính giá sơn cửa trơn
              else if (materialType === 'tron') {
                if (isPaint) {
                  this.doorsData.push({
                    type: 'normal',
                    quantity: area,
                    subtype: 'dulux',
                    unit: 'm²',
                  });
                }
              }
            }
          });
          // value.group.traverse(child => {
          //   if (child.isMesh && child.name.includes('CANH-LAT')) {
          //     const { x, y, z } = child.userData.newSize ?? {};
          //     this.componentsData.forEach(component => {
          //       if (component.type === 'hinges') {
          //         component.quantity += 2;
          //       }
          //       if (component.type === 'liftSupport' && !!x && !!y && !!z) {
          //         component.quantity += 1;
          //       }
          //     });
          //   }
          // });
        }
      } catch (error) {
        console.log(error);
      }
    });
  };

  /**
   * Bóc tách phụ kiện và thiết bị
   * @param {Map} modules Map các module trong tủ
   * @returns {Object} equipments: mảng thiết bị, handles: mảng tay nắm, clothesHangers: mảng thanh treo quần áo
   */
  disassemblyAccessoryAndEquipment = ({ modules }) => {
    Array.from(modules).forEach(([key, value]) => {
      try {
        const cabinetType = value.group.userData.cabinetType ?? '';
        const moduleType = value.moduleType ?? '';
        if (['present', 'curved_block'].some(type => moduleType.includes(type)))
          return;

        const listInside = value.listInside;
        listInside.map(inside => {
          const box = new THREE.Box3().setFromObject(inside.gltf);
          const { x, y, z } =
            inside.gltf?.userData?.newSize ?? box.getSize(new THREE.Vector3());
          const width = Math.max(x, z);
          const height = y;
          const area = roundTo(width * height, 6);
          if (this.HaveRail.some(item => inside.type === item)) {
            // this.countRail += 2;
            this.componentsData.forEach(component => {
              if (component.type === 'rails') {
                component.quantity += 2;
              }
            });
          }
          if (this.EquipmentItem.some(item => inside.type === item)) {
            this.specialsData.push({
              type: 'equipments',
              quantity: 1,
              customPrice: inside.price ?? 0,
              name: inside.name,
              material: inside.material,
              thumbnail_url: inside?.thumbnail_url,
              id: inside?._id ?? inside?.id,
              unit: 'pcs',
            });
          } else if ([InsideType.LOCK].some(item => item === inside.type)) {
            this.accessoriesData.push({
              type: 'standardLock',
              quantity: 1,
              name: inside.name,
              material: inside.material,
              thumbnail_url: inside?.thumbnail_url,
              id: inside?._id ?? inside?.id,
              unit: 'pcs',
            });
          } else if ([InsideType.HANDLE].some(item => item === inside.type)) {
            this.accessoriesData.push({
              type: 'handles',
              quantity: 1,
              customPrice: inside.price ?? 0,
              name: inside.name,
              material: inside.material,
              thumbnail_url: inside?.thumbnail_url,
              id: inside?._id ?? inside?.id,
              unit: 'pcs',
            });
          } else if (
            [InsideType.LIFT_SUPPORT].some(item => item === inside.type)
          ) {
            this.componentsData.push({
              type: 'liftSupport',
              quantity: 1,
              customPrice: inside.price ?? 0,
              name: inside.name,
              material: inside.material,
              thumbnail_url: inside?.thumbnail_url,
              id: inside?._id ?? inside?.id,
              unit: 'pcs',
            });
          } else if (
            [InsideType.CLOTHES_HANGER].some(item => item === inside.type)
          ) {
            const box = new THREE.Box3().setFromObject(inside.gltf);
            const size = box.getSize(new THREE.Vector3());
            const length = roundTo(Math.max(size.x, size.y, size.z), 3);

            this.accessoriesData.push({
              type: 'clothesHangers',
              quantity: length,
              name: inside.name,
              material: inside.material,
              thumbnail_url: inside?.thumbnail_url,
              unit: 'm',
            });
          } else if (this.LEDItem.some(item => item === inside.type)) {
            const box = new THREE.Box3().setFromObject(inside.gltf);
            const size = box.getSize(new THREE.Vector3());
            const length = roundTo(Math.max(size.x, size.y, size.z), 3);

            this.accessoriesData.push({
              type: 'leds',
              quantity: length,
              thumbnail_url: inside?.thumbnail_url,
              unit: 'm',
            });
            this.laborsData.push({
              type: 'assembly',
              subtype: 'led',
              quantity: length,
              unit: 'm',
            });
          } else if (
            [InsideType.KHUNG_SAT, InsideType.CHAN_ROI_TV].some(
              item => item === inside.type
            )
          ) {
            this.accessoriesData.push({
              type: 'legs',
              quantity: 1,
              customPrice: inside.price ?? 0,
              name: inside.name,
              material: inside.material,
              thumbnail_url: inside?.thumbnail_url,
              unit: 'pcs',
              id: inside?._id ?? inside?.id,
            });
          } else if (
            [InsideType.MIRROR_DOOR].some(item => item === inside.type)
          ) {
            this.accessoriesData.push({
              type: 'mirrors',
              quantity: area,
              thumbnail_url: inside?.thumbnail_url,
              unit: 'm²',
              id: inside?._id ?? inside?.id,
            });
          }
        });
        value.group.children.forEach(group => {
          group.traverse(child => {
            if (
              child.isMesh &&
              !['BCT', 'BCP'].some(item => child.name.includes(item))
            ) {
              const mesh = child;
              const box = new THREE.Box3().setFromObject(mesh);
              const { x, y, z } =
                mesh.userData.newSize ?? box.getSize(new THREE.Vector3());
              const width = Math.max(x, z);
              const height = y;
              const area = roundTo(width * height, 6);
              if (['VACH-GUONG'].some(item => mesh.name.includes(item))) {
                this.laborsData.forEach(labor => {
                  if (
                    labor.type === 'assembly' &&
                    labor.subtype === 'wallPanelMirror'
                  ) {
                    labor.quantity += area;
                    labor.unit = 'm²';
                  }
                });
              } else if (
                ['GUONG'].some(item => mesh.name.includes(item)) &&
                mesh.userData.type !== InsideType.MIRROR_DOOR
              ) {
                if (mesh.name.includes('GUONG-BTD')) return;
                this.accessoriesData.push({
                  type: 'mirrors',
                  quantity: area,
                  // thumbnail_url: inside?.thumbnail_url,
                  // id: inside?._id ?? inside?.id,
                  unit: 'm²',
                });
              } else if (['VACH-TRON'].some(item => mesh.name.includes(item))) {
                this.laborsData.forEach(labor => {
                  if (
                    labor.type === 'assembly' &&
                    labor.subtype === 'wallPanelMelamine'
                  ) {
                    labor.quantity += area;
                    labor.unit = 'm²';
                  }
                });
              } else if (['VACH-LAM'].some(item => mesh.name.includes(item))) {
                this.laborsData.forEach(labor => {
                  if (
                    labor.type === 'assembly' &&
                    labor.subtype === 'slatWallPartition'
                  ) {
                    labor.quantity += area;
                    labor.unit = 'm²';
                  }
                });
              } else if (['DAY'].some(item => mesh.name.includes(item))) {
                this.componentsData.forEach(component => {
                  if (component.type === 'connectors') {
                    component.quantity += 4;
                  }
                });
              } else if (['BIA'].some(item => mesh.name.includes(item))) {
                this.componentsData.forEach(component => {
                  if (component.type === 'connectors') {
                    component.quantity += 2;
                  }
                });
              } else if (
                ['MAIN-HP-', 'MAIN-W-'].some(item => mesh.name.includes(item))
              ) {
                this.componentsData.forEach(component => {
                  if (component.type === 'connectors') {
                    component.quantity += 4;
                  }
                });
              }
            } else if (
              child.isGroup &&
              [InsideType.VPANEL2, InsideType.HPANEL_SHOE].includes(
                group.userData.type
              )
            ) {
              this.componentsData.forEach(component => {
                if (component.type === 'connectors') {
                  component.quantity += 4;
                }
              });
            }
          });
        });
      } catch (error) {
        console.error('Error disassemblyAccessoryAndEquipment: ', error);
      }
    });

    if (this.accessoriesData.filter(item => item.type === 'leds').length) {
      this.accessoriesData.forEach(item => {
        if (item.type === 'lightSwitches') {
          item.quantity += 1;
        }
        if (item.type === 'ledDrivers') {
          item.quantity += 1;
        }
      });
    }
  };

  /**
   * Bóc tách đá mặt bàn và kính chắn bếp
   * @param {THREE.Scene} scene Scene chứa các mesh đá mặt bàn và kính chắn bếp
   * @returns {Object} countertop: mảng đá mặt bàn, backsplash: mảng kính chắn bếp
   */
  disassemblyStoneGlass = ({ scene }) => {
    scene?.traverse(child => {
      if (child.isMesh && child.userData?.type === ModuleType.COUNTERTOP) {
        const box = new THREE.Box3().setFromObject(child);
        const size = box.getSize(new THREE.Vector3());
        const countertopDepth = child.userData.countertopDepth;
        const countertopWidth = child.userData.countertopWidth;

        let length = 0;
        let depth = 0.61;
        if (countertopDepth !== undefined) {
          if (
            nearlyEqual(roundTo(size.x, 3), countertopDepth + 0.03) ||
            nearlyEqual(roundTo(size.x, 3), countertopDepth)
          ) {
            length = size.z;
            depth = size.x;
          } else {
            length = size.x;
            depth = size.z;
          }
        } else if (countertopWidth !== undefined) {
          length = countertopWidth;
          depth = size.z;
        } else {
          const orientation = child.userData.orientation;
          if (['ROTATED_270', 'ROTATED_90'].includes(orientation)) {
            length = size.x;
            depth = size.z;
          } else {
            length = size.z;
            depth = size.x;
          }
        }
        let formularPrice = child.userData.formularPrice?.replace(/,/g, '.');
        // const extra = depth - 0.61;
        let extra = 0;
        if (!lessOrEqual(roundTo(depth, 4), 0.61)) {
          if (lessOrEqual(roundTo(depth, 4), 0.75)) {
            extra = 0.05;
          } else if (lessOrEqual(roundTo(depth, 4), 0.85)) {
            extra = 0.15;
          } else if (lessOrEqual(roundTo(depth, 4), 0.95)) {
            extra = 0.25;
          } else {
            extra = 0.3;
          }
        }
        let price = child.userData.texturePrice || 0;
        if (formularPrice?.length) {
          for (const [key, value] of Object.entries({
            giagoc: child.userData.texturePrice || 0,
            dosau: !lessOrEqual(extra, 0) ? extra : 0,
          })) {
            const regex = new RegExp(`\\b${key}\\b`, 'g');
            formularPrice = formularPrice.replace(regex, value.toString());
          }
          // FIXED [C1]: Replace eval() with safe evaluator
          try {
            price = roundLeft(eval(formularPrice), 4);
          } catch (e) {
            console.warn('Failed to evaluate countertop formula:', e.message);
            price = child.userData.texturePrice || 0;
          }
        }
        this.specialsData.push({
          type: 'countertop',
          quantity: roundTo(length, 3),
          customPrice: price,
          id: child.userData?.textureId,
          formularPrice,
          unit: 'm',
        });
      } else if (
        child.isMesh &&
        child.userData?.type === ModuleType.BACKSPLASH
      ) {
        const box = new THREE.Box3().setFromObject(child);
        const size = box.getSize(new THREE.Vector3());
        const length = roundTo(Math.max(size.x, size.z), 3);
        const depth = size.y;
        let formularPrice = child.userData.formularPrice?.replace(/,/g, '.');
        // const extra = depth - 0.61;
        let extra = 0;
        if (!lessOrEqual(roundTo(depth, 4), 0.61)) {
          if (lessOrEqual(roundTo(depth, 4), 0.75)) {
            extra = 0.05;
          } else if (lessOrEqual(roundTo(depth, 4), 0.85)) {
            extra = 0.15;
          } else if (lessOrEqual(roundTo(depth, 4), 0.95)) {
            extra = 0.25;
          } else {
            extra = 0.3;
          }
        }
        let price = child.userData.texturePrice || 0;
        if (formularPrice?.length) {
          for (const [key, value] of Object.entries({
            giagoc: child.userData.texturePrice || 0,
            dosau: !lessOrEqual(extra, 0) ? extra : 0,
          })) {
            const regex = new RegExp(`\\b${key}\\b`, 'g');
            formularPrice = formularPrice.replace(regex, value.toString());
          }
          // FIXED [C1]: Replace eval() with safe evaluator
          try {
            price = roundLeft(eval(formularPrice), 4);
          } catch (e) {
            console.warn('Failed to evaluate backsplash formula:', e.message);
            price = child.userData.texturePrice || 0;
          }
        }
        this.specialsData.push({
          type: 'backsplash',
          quantity: length,
          customPrice: price,
          id: child.userData?.textureId,
          formularPrice,
          unit: 'm',
        });
      } else if (
        child.isMesh &&
        child.userData?.type === ModuleType.LED_DECOR
      ) {
        const box = new THREE.Box3().setFromObject(child);
        const size = box.getSize(new THREE.Vector3());
        const length = roundTo(Math.max(size.x, size.z, size.y), 3);
        this.accessoriesData.push({
          type: 'ledsDecor',
          quantity: length,
          thumbnail_url: child.userData?.thumbnail_url,
          unit: 'm',
        });

        this.laborsData.push({
          type: 'assembly',
          subtype: 'led',
          quantity: length,
          unit: 'm',
        });
      }
    });

    if (this.accessoriesData.filter(item => item.type === 'ledsDecor').length) {
      this.accessoriesData.forEach(item => {
        if (item.type === 'lightSwitches') {
          item.quantity += 1;
        }
        if (item.type === 'ledDrivers') {
          item.quantity += 1;
        }
      });
    }
  };

  /**
   * Kiểm tra 2 bounding box có tiếp xúc nhau không.
   * So trực tiếp khoảng chồng lấn trên từng trục thay vì bắn tia từ tâm mặt,
   * nên 2 tủ lệch tâm / khác kích thước vẫn nhận ra được là đang dính nhau.
   * @param {THREE.Box3} boxA
   * @param {THREE.Box3} boxB
   * @param {number} epsilon Ngưỡng (m) coi 2 mặt là chạm nhau
   * @returns {boolean}
   */
  areBoxesTouching = (boxA, boxB, epsilon = 1e-3) => {
    // overlap > 0: chồng lấn trên trục đó; overlap < 0: cách nhau |overlap|
    const overlaps = ['x', 'y', 'z'].map(
      axis =>
        Math.min(boxA.max[axis], boxB.max[axis]) -
        Math.max(boxA.min[axis], boxB.min[axis])
    );

    // Hở quá epsilon ở bất kỳ trục nào -> 2 tủ rời nhau
    if (overlaps.some(overlap => overlap < -epsilon)) return false;

    // Phải chồng lấn thật sự trên ít nhất 2 trục thì mới là chạm mặt.
    // Chỉ 1 trục chồng lấn nghĩa là 2 tủ chạm cạnh, 0 trục là chạm góc.
    return overlaps.filter(overlap => overlap > epsilon).length >= 2;
  };

  /**
   * Gom các module tiếp xúc nhau thành từng cụm liên thông.
   * Chỉ so các module trong danh sách truyền vào nên tường / sàn / trần không
   * bao giờ bị tính là hàng xóm, dù tủ luôn áp sát tường.
   * @param {Array<Object>} modulesOnWall Danh sách module cần gom (module object, không phải group)
   * @param {number} epsilon Ngưỡng (m) coi 2 module là dính nhau
   * @returns {Array<Array<Object>>} Mảng các cụm, mỗi cụm là mảng module dính nhau
   */
  groupAdjacentModules = (modulesOnWall, epsilon = 1e-3) => {
    // Dùng chung cách tính bbox với bước tính chiều dài cụm phía dưới
    const boxes = modulesOnWall.map(module =>
      this.dimensionSystem.calculateModulesBoundingBox([module.group])
    );

    // Union-Find trên index: mỗi module ban đầu là một cụm riêng
    const parents = modulesOnWall.map((_, index) => index);
    const find = index => {
      let root = index;
      while (parents[root] !== root) {
        parents[root] = parents[parents[root]]; // path halving
        root = parents[root];
      }
      return root;
    };
    const union = (indexA, indexB) => {
      const rootA = find(indexA);
      const rootB = find(indexB);
      if (rootA !== rootB) parents[rootB] = rootA;
    };

    for (let i = 0; i < boxes.length; i++) {
      if (boxes[i].isEmpty()) continue;
      for (let j = i + 1; j < boxes.length; j++) {
        if (boxes[j].isEmpty()) continue;
        if (this.areBoxesTouching(boxes[i], boxes[j], epsilon)) union(i, j);
      }
    }

    const clusters = new Map();
    modulesOnWall.forEach((module, index) => {
      const root = find(index);
      if (!clusters.has(root)) clusters.set(root, []);
      clusters.get(root).push(module);
    });

    return Array.from(clusters.values());
  };

  /**
   * Bóc tách các module thành các loại tủ khác nhau
   * @param {Map} modules Map các module trong tủ
   * @returns {Object} cabinets: các loại tủ đã được bóc tách
   */
  disassemblyProduct = ({ modules }) => {
    const kitchenUpperAndCeiling = {
      wall1: [],
      wall2: [],
      wall3: [],
      wall4: [],
    };
    Array.from(modules).forEach(([key, value]) => {
      try {
        const cabinetType =
          value.cabinet?.type ?? value.group.userData.cabinetType ?? '';
        const moduleType = value.moduleType ?? '';
        if (moduleType.includes('present')) return;

        const textureFrame = value.textures?.get('frame');
        const currentSize = value.formularController?.currentDimensions;
        if (textureFrame === undefined || textureFrame?.supplier === undefined)
          this.noTexture = true;

        const supplierName = textureFrame?.supplier?.name?.includes('An Cường')
          ? 'AC'
          : textureFrame?.supplier?.name?.includes('KES')
            ? 'KES'
            : textureFrame?.supplier?.name;
        const material = textureFrame?.supplier?.materialType ?? '';
        const height = currentSize?.height ?? 0;
        const width = currentSize?.width ?? 0;
        const depth = currentSize?.depth ?? 0;
        const rank = lessOrEqual(height, 0.6)
          ? 'rank1'
          : lessOrEqual(height, 1.5)
            ? 'rank2'
            : 'rank3';
        // !lessOrEqual(height, 1) && lessOrEqual(height, 2)
        //   ? 'rank3'
        //   : !lessOrEqual(height, 0.6) && lessOrEqual(height, 1)
        //     ? 'rank2'
        //     : 'rank1';

        let length = 0;
        let area = 0;

        const { bonusWidth, bonusHeight } = this.checkTrimCover({
          cabinetCoverPos: value.group.userData.cabinetCoverPos,
          cabinetTrimPos: value.group.userData.cabinetTrimPos,
        });

        if (
          ['corner'].some(item =>
            value.group.userData.moduleType.includes(item)
          )
        ) {
          const rongK1 = value.group.userData.moduleData.rongK1 || 0;
          const rongK2 = value.group.userData.moduleData.rongK2 || 0;
          length = roundTo(rongK1 + rongK2 - depth + bonusWidth, 3);
          area =
            roundTo(rongK1 + rongK2 - depth + bonusWidth, 3) *
            roundTo(height + bonusHeight, 3);
        } else {
          length = roundTo(width + bonusWidth, 3);
          area =
            roundTo(width + bonusWidth, 3) * roundTo(height + bonusHeight, 3);
        }

        if (value.formularController?.currentOptions) {
          const { bct, bcp } = value.formularController.currentOptions;
          if (bct) {
            this.specialsData.push({
              type: 'curveBlocks',
              quantity: 1,
              subtype: `${rank}.${supplierName}.${material}`,
              unit: 'pcs',
            });
          }
          if (bcp) {
            this.specialsData.push({
              type: 'curveBlocks',
              quantity: 1,
              subtype: `${rank}.${supplierName}.${material}`,
              unit: 'pcs',
            });
          }
        }

        if (moduleType.includes('curved_block')) {
          this.specialsData.push({
            type: 'curveBlocks',
            quantity: 1,
            subtype: `${rank}.${supplierName}.${material}`,
            unit: 'pcs',
          });
        } else if (cabinetType.includes('kitchen')) {
          if (moduleType.includes('totl')) {
            this.laborsData.forEach(labor => {
              if (labor.type === 'assembly' && labor.subtype === 'totl') {
                labor.quantity += area;
                return;
              }
            });
          } else if (moduleType.includes('dry')) {
            this.laborsData.forEach(labor => {
              if (labor.type === 'assembly' && labor.subtype === 'dry') {
                labor.quantity += area;
                return;
              }
            });
          } else if (moduleType.includes('dotke')) {
            this.laborsData.forEach(labor => {
              if (labor.type === 'assembly' && labor.subtype === 'shelf') {
                labor.quantity += length;
                return;
              }
            });
          } else if (moduleType.includes('lower')) {
            this.laborsData.forEach(labor => {
              if (
                labor.type === 'assembly' &&
                labor.subtype === 'kitchenLower'
              ) {
                labor.quantity += length;
                return;
              }
            });
          } else if (
            ['upper', 'ceiling'].some(item => moduleType.includes(item))
          ) {
            // Quy góc xoay Y về 1 trong 4 hướng: 0, PI/2, PI, -PI/2
            // (dùng sin/cos thay vì so sánh === để tránh sai số dấu phẩy động)
            const rotY = value.group.rotation.y;
            const sinY = Math.sin(rotY);
            const cosY = Math.cos(rotY);
            const EPSILON = 1e-6;

            if (cosY > 1 - EPSILON) {
              // rotation.y === 0
              kitchenUpperAndCeiling.wall1.push(value);
            } else if (sinY > 1 - EPSILON) {
              // rotation.y === PI / 2
              kitchenUpperAndCeiling.wall2.push(value);
            } else if (cosY < -1 + EPSILON) {
              // rotation.y === PI (hoặc -PI)
              kitchenUpperAndCeiling.wall3.push(value);
            } else if (sinY < -1 + EPSILON) {
              // rotation.y === -PI / 2 (hoặc 3PI/2)
              kitchenUpperAndCeiling.wall4.push(value);
            }
          }
        } else if (cabinetType.includes('wardrobe')) {
          this.laborsData.forEach(labor => {
            if (labor.type === 'assembly' && labor.subtype === 'wardrobe') {
              labor.quantity += area;
              return;
            }
          });
        } else if (cabinetType.includes('shoe')) {
          if (moduleType.includes('vach_lam')) {
            this.laborsData.forEach(labor => {
              if (
                labor.type === 'assembly' &&
                labor.subtype === 'slatWallPartition'
              ) {
                labor.quantity += area;
                return;
              }
            });
          } else if (moduleType.includes('vach_guong')) {
            this.laborsData.forEach(labor => {
              if (
                labor.type === 'assembly' &&
                labor.subtype === 'wallPanelMirror'
              ) {
                labor.quantity += area;
                return;
              }
            });
          } else if (moduleType.includes('vach_tron')) {
            this.laborsData.forEach(labor => {
              if (
                labor.type === 'assembly' &&
                labor.subtype === 'wallPanelMelamine'
              ) {
                labor.quantity += area;
                return;
              }
            });
          } else if (moduleType.includes('bench')) {
            this.laborsData.forEach(labor => {
              if (labor.type === 'assembly' && labor.subtype === 'shoeBench') {
                labor.quantity += area;
                return;
              }
            });
          } else {
            this.laborsData.forEach(labor => {
              if (
                labor.type === 'assembly' &&
                labor.subtype === 'shoeCabinet'
              ) {
                labor.quantity += area;
                return;
              }
            });
          }
        } else if (cabinetType.includes('tv')) {
          if (moduleType.includes('decorative')) {
            this.laborsData.forEach(labor => {
              if (labor.type === 'assembly' && labor.subtype === 'decorative') {
                labor.quantity += length;
                return;
              }
            });
          } else {
            this.laborsData.forEach(labor => {
              if (labor.type === 'assembly' && labor.subtype === 'tv') {
                labor.quantity += length;
                return;
              }
            });
          }
        } else if (cabinetType.includes('decorative')) {
          this.laborsData.forEach(labor => {
            if (labor.type === 'assembly' && labor.subtype === 'decorative') {
              labor.quantity += length;
              return;
            }
          });
        } else if (cabinetType.includes('bed')) {
          // Giường bục
          if (moduleType.includes('lower')) {
            this.laborsData.forEach(labor => {
              if (labor.type === 'assembly' && labor.subtype === 'bedLower') {
                // Giường tích diện tích theo dài x sâu
                labor.quantity += width * depth;
                return;
              }
            });
          }
          // this.laborsData.forEach(labor => {
          //   if (labor.type === 'assembly' && labor.subtype === 'bed') {
          //     labor.quantity += 1;
          //     return;
          //   }
          // });
        }
      } catch (error) {
        console.error('Error disassemblyProduct: ', error);
      }
    });

    // Tủ xoay 0 / PI chạy dọc trục Z, tủ xoay +-PI/2 chạy dọc trục X
    const runAxisByWall = { wall1: 'z', wall3: 'z', wall2: 'x', wall4: 'x' };
    Object.entries(kitchenUpperAndCeiling).forEach(([key, modulesOnWall]) => {
      if (!modulesOnWall.length) return;
      const runAxis = runAxisByWall[key];
      const crossAxis = runAxis === 'x' ? 'z' : 'x';
      // Cùng một hướng vẫn có thể là nhiều đoạn tủ rời nhau -> tách từng cụm
      // dính nhau rồi tính chiều dài riêng, tránh bbox ăn cả khoảng trống
      this.groupAdjacentModules(modulesOnWall).forEach(cluster => {
        const bbox = this.dimensionSystem.calculateModulesBoundingBox(
          cluster.map(module => module.group)
        );
        const size = bbox.getSize(new THREE.Vector3());
        let length = size[runAxis];

        // Tủ góc hình chữ L chỉ được xếp vào 1 tường nên bbox mới phủ 1 cánh
        // theo trục chạy, cánh còn lại nằm trên trục vuông góc -> cộng thêm
        // (trừ độ sâu vì phần giao nhau của 2 cánh đã tính ở cánh đầu)
        cluster.forEach(module => {
          if (!module.group.userData.moduleType?.includes('corner')) return;
          const cornerSize = this.dimensionSystem
            .calculateModulesBoundingBox([module.group])
            .getSize(new THREE.Vector3());
          const depth =
            module.formularController?.currentDimensions?.depth ?? 0;
          length += Math.max(cornerSize[crossAxis] - depth, 0);
        });

        this.laborsData.forEach(labor => {
          if (labor.type === 'assembly' && labor.subtype === 'kitchenCeiling') {
            labor.quantity += length;
            return;
          }
        });
      });
    });
  };

  /**
   * Bóc tách các phần của module
   * @param {Map} modules Map các module trong tủ
   * @returns {Array} parts Mảng các phần đã được bóc tách
   */
  disassemblyPart = ({ modules }) => {
    Array.from(modules).forEach(([key, value]) => {
      try {
        const moduleType = value.moduleType ?? '';
        if (
          !['curved_block', 'present'].some(type => moduleType.includes(type))
        ) {
          const textures = value.textures;
          const doorTexture = textures.get('DOOR');
          const materialType =
            doorTexture?.supplier?.materialType?.toLowerCase();
          value.group.children.forEach(group => {
            // kiểm tra phần tử này nếu là cửa thì thêm vào danh sách
            if (
              group.isGroup &&
              group.userData.type === InsideType.DOOR &&
              group.userData.isInside &&
              group.userData.materialType !== 'nhom_kinh' &&
              !materialType?.includes('acrylic')
            ) {
              group?.traverse(child => {
                if (child.isMesh && child.userData.notNesting !== true) {
                  this.resolverPart(child, moduleType);
                }
              });
            }
            // group này chứa mesh chính của module
            if (group.isGroup && ['Scene'].includes(group.name)) {
              // Phụ kiện không duyệt sâu
              if (
                !this.EquipmentItem.some(
                  item => item === group.userData.type
                ) &&
                !this.LEDItem.some(item => item === group.userData.type) &&
                InsideType.DOOR !== group.userData.type &&
                ![InsideType.KHUNG_SAT, InsideType.CHAN_ROI_TV].includes(
                  group.userData.type
                )
              ) {
                group?.traverse(child => {
                  if (
                    child.isMesh &&
                    !['BCT', 'BCP'].some(item => child.name.includes(item)) &&
                    !['GUONG'].some(item => child.name === item)
                  ) {
                    this.resolverPart(child, moduleType);
                  }
                });
              }
            }
            // group này chứa xắn dọc gần đỉnh của module
            else if (
              group.isGroup &&
              [InsideType.VPANEL2].includes(group.userData.type)
            ) {
              this.resolverPart(group);
            } else if (
              group.isGroup &&
              [InsideType.HPANEL_SHOE].includes(group.userData.type)
            ) {
              group?.traverse(child => {
                if (child.isMesh) {
                  this.resolverPart(child, moduleType);
                }
              });
            }
            // phần còn lại là các xắn dọc, xắn ngang, bản lề, bạt tủ,
            else if (
              group.isMesh &&
              ![InsideType.MIRROR_DOOR].includes(group.userData.type)
            ) {
              const mesh = group;
              if (
                (['MAIN-W-', 'MAIN-HP-', 'BRACE'].some(item =>
                  mesh.name.includes(item)
                ) ||
                  [
                    InsideType.BRACE,
                    InsideType.VPANEL,
                    InsideType.HPANEL,
                    // InsideType.DOOR,
                  ].some(item => mesh.userData.type === item)) &&
                !['BCT', 'BCP', 'GUONG'].some(item => mesh.name.includes(item))
              ) {
                this.resolverPart(mesh, moduleType);
              }
            }
          });
        }
      } catch (err) {
        // console.error('Error disassemblyPart: ', err);
        throw new Error(`Error disassemblyPart: ${err}`);
      }
    });

    const scene = this.cabinetManager?.sceneManager?.scene;
    // Kiểm tra nẹp trong scene
    if (scene) {
      scene?.updateMatrixWorld();
      scene?.traverse(child => {
        if (
          child.isMesh &&
          ['GROUP_TOP', 'GROUP_EDGE', 'GROUP_LAST', 'CABINET_COVER'].some(
            item => child.userData.name?.includes(item)
          )
        ) {
          this.resolverPart(child, 'cabinetTrim');
        }
      });
    }
    return this.parts;
  };

  resolverPart = (mesh, moduleType) => {
    // Bỏ qua tấm hậu bị ẩn không dàn ván
    if ((mesh.visible === false && mesh.name.includes('HAU')) || mesh.userData?.type === InsideType.STOOL_CUSHION) {
      return;
    }

    if (
      mesh.userData.type === InsideType.DOOR_TEMPLATE ||
      (mesh.userData?.visible === false &&
        mesh.parent.userData.type !== InsideType.DOOR)
    ) {
      return;
    }

    const texture = {
      textureId: mesh.userData.textureId,
      supplier: mesh.userData.supplier,
      textureCode: mesh.userData.textureCode,
      texturePrice: mesh.userData.texturePrice,
      no_grain: mesh.userData.no_grain, // đánh dấu ván có vân hay không,
      special: mesh.userData.specialTexture,
    };
    if (
      (this.useSpecialTexture === null || this.useSpecialTexture !== false) &&
      texture.textureId
    ) {
      this.useSpecialTexture = mesh.userData.specialTexture ?? false;
    }

    // Đảm bảo matrix world được update
    mesh.updateMatrixWorld(true);

    const box = new THREE.Box3().setFromObject(mesh);
    const size = mesh.userData.newSize ?? box.getSize(new THREE.Vector3());

    const orientation = GeometryUtils.getModuleOrientation(mesh);
    let sizeArray;
    const dimensions = [size.x, size.y, size.z];
    if (['CABINET_COVER'].some(item => mesh.userData.name?.includes(item))) {
      const width = size.y;
      const height = Math.max(size.x, size.z);
      const thickness = Math.min(size.x, size.z);

      sizeArray = [width, height, thickness];
    }
    // else if (
    //   ['GROUP_TOP', 'GROUP_EDGE'].some(item => {
    //     return mesh.userData.name?.includes(item);
    //   })
    // ) {
    //   const thickness = dimensions.reduce((prev, curr) =>
    //     Math.abs(curr - 0.017) < Math.abs(prev - 0.017) ? curr : prev
    //   );
    //   const height = dimensions.reduce((prev, curr) =>
    //     Math.abs(curr - 0.03) < Math.abs(prev - 0.03) ? curr : prev
    //   );
    //   const width = dimensions.find(dim => dim !== thickness && dim !== height);

    //   sizeArray = [width, height, thickness];
    // }
    else if (
      ['GROUP_EDGE'].some(item => {
        return mesh.userData.name?.includes(item);
      })
    ) {
      // FIXED [I6]: Add initial value to reduce and NaN guard
      const thickness = dimensions.reduce(
        (prev, curr) =>
          Math.abs(curr - 0.017) < Math.abs(prev - 0.017) ? curr : prev,
        dimensions[0]
      );
      const height = dimensions.reduce(
        (prev, curr) =>
          Math.abs(curr - this.widthCabinetTrim) <
          Math.abs(prev - this.widthCabinetTrim)
            ? curr
            : prev,
        dimensions[0]
      );
      const width = dimensions.find(dim => dim !== thickness && dim !== height);

      if (
        isNaN(width) ||
        isNaN(height) ||
        isNaN(thickness) ||
        width === undefined
      ) {
        console.warn(
          'NaN detected in GROUP_EDGE resolverPart, skipping:',
          mesh.name
        );
        return;
      }
      sizeArray = [width, height, thickness];
    } else if (
      ['GROUP_TOP', 'GROUP_LAST'].some(item => {
        return mesh.userData.name?.includes(item);
      })
    ) {
      // FIXED [I6]: Add initial value to reduce and NaN guard
      const thickness = dimensions.reduce(
        (prev, curr) =>
          Math.abs(curr - 0.017) < Math.abs(prev - 0.017) ? curr : prev,
        dimensions[0]
      );
      const height = dimensions.reduce(
        (prev, curr) =>
          Math.abs(curr - this.heightCabinetTrim) <
          Math.abs(prev - this.heightCabinetTrim)
            ? curr
            : prev,
        dimensions[0]
      );
      const width = dimensions.find(dim => dim !== thickness && dim !== height);

      if (
        isNaN(width) ||
        isNaN(height) ||
        isNaN(thickness) ||
        width === undefined
      ) {
        console.warn(
          'NaN detected in GROUP_TOP/GROUP_LAST resolverPart, skipping:',
          mesh.name
        );
        return;
      }
      sizeArray = [width, height, thickness];
      // } else if (['FGR-H', 'SGR-H'].some(item => mesh.name.includes(item))) {
      //   //width :2m4 ,height :1m2
      //   const thickness = size.y;
      //   const width = Math.max(size.x, size.z);
      //   const height = Math.min(size.x, size.z);
      //   sizeArray = [width, height, thickness];
      // } else if (['FLW-H', 'SLW-H'].some(item => mesh.name.includes(item))) {
      //   const height = size.y;
      //   const width = Math.max(size.x, size.z);
      //   const thickness = Math.min(size.x, size.z);
      //   sizeArray = [width, height, thickness];
      // } else if (['FLW-V', 'SDW-V'].some(item => mesh.name.includes(item))) {
      //   const width = size.y;
      //   const height = Math.max(size.x, size.z);
      //   const thickness = Math.min(size.x, size.z);
      //   sizeArray = [width, height, thickness];
      // }
    } else if (['FGR-H'].some(item => mesh.name.includes(item))) {
      //width :2m4 ,height :1m2
      const thickness = size.y;
      const width = size.z;
      const height = size.x;
      sizeArray = [width, height, thickness];
    } else if (['SGR-H'].some(item => mesh.name.includes(item))) {
      //width :2m4 ,height :1m2
      const thickness = size.y;
      const width = size.x;
      const height = size.z;
      sizeArray = [width, height, thickness];
    } else if (['FLW-H', 'SLW-H'].some(item => mesh.name.includes(item))) {
      const height = size.y;
      const width = Math.max(size.x, size.z);
      const thickness = Math.min(size.x, size.z);
      sizeArray = [width, height, thickness];
    } else if (['FLW-V', 'SDW-V'].some(item => mesh.name.includes(item))) {
      const width = size.y;
      const height = Math.max(size.x, size.z);
      const thickness = Math.min(size.x, size.z);
      sizeArray = [width, height, thickness];
    }
    // Xử lý kích thước chi tiết trước khi dàn ván
    // Các chi tiết có tên ["DAY", "MAIN-W-", "TAM-DAY", "XAN-NGANG", "NOC"] sẽ có y là độ dày ván,
    // chiều dài và chiều rộng phụ thuộc vào chiều xoay
    // Các chi tiết còn lại sẽ có y là chiều cao (chiều đứng), min(x, z) là độ dày ván, chiều dài còn lại, xếp ngang với khổ ván 2.44/1.22
    // Các chi tiết có tên ["CHAN", "XUONG", "NEP","BRACE" ] xếp dọc với khổ ván 2.44/1.22
    else if (['TAM_DAY'].some(item => mesh.name.includes(item))) {
      const thickness = size.y;
      let height, width;
      if (mesh.userData.newSize) {
        height = size.z;
        width = size.x;
      } else {
        if (['ROTATED_270', 'ROTATED_90'].includes(orientation)) {
          height = size.z;
          width = size.x;
        } else if (['NORMAL', 'ROTATED_180'].includes(orientation)) {
          height = size.x;
          width = size.z;
        }
      }

      sizeArray = [width, height, thickness];
    } else if (
      ['DAY', 'XAN-NGANG', 'XAN-BO-CONG', 'NOC', 'DOTKE', 'THANH-GO-TREO'].some(
        item => mesh.name.includes(item)
      )
    ) {
      const thickness = size.y;
      let height, width;
      if (mesh.userData.newSize) {
        height = size.x;
        width = size.z;
      } else {
        if (['ROTATED_270', 'ROTATED_90'].includes(orientation)) {
          height = size.x;
          width = size.z;
        } else if (['NORMAL', 'ROTATED_180'].includes(orientation)) {
          height = size.z;
          width = size.x;
        }
      }

      if (['DAY-1', 'NOC-1'].includes(mesh.name)) {
        if (['ROTATED_270', 'ROTATED_90'].includes(orientation)) {
          height = size.z;
          width = size.x;
        } else if (['NORMAL', 'ROTATED_180'].includes(orientation)) {
          height = size.x;
          width = size.z;
        }
      }

      if (['DAY-2', 'NOC-2'].includes(mesh.name)) {
        if (['ROTATED_270', 'ROTATED_90'].includes(orientation)) {
          height = size.x;
          width = size.z;
        } else if (['NORMAL', 'ROTATED_180'].includes(orientation)) {
          height = size.z;
          width = size.x;
        }
      }
      sizeArray = [width, height, thickness];
    } else if (['MAIN-W-'].some(item => mesh.name.includes(item))) {
      const thickness = size.y;
      let height, width;
      if (mesh.userData.newSize) {
        height = size.z;
        width = size.x;
      } else {
        if (['ROTATED_270', 'ROTATED_90'].includes(orientation)) {
          height = size.z;
          width = size.x;
        } else if (['NORMAL', 'ROTATED_180'].includes(orientation)) {
          height = size.x;
          width = size.z;
        }
      }

      sizeArray = [width, height, thickness];

      // Xắn lật chưa thể xác định động dày, đặt mặc định 17mm
    } else if (['HPANEL-'].some(item => mesh.name.includes(item))) {
      const thickness = 0.017;
      let height, width;
      if (mesh.userData.newSize) {
        height = size.z;
        width = size.x;
      } else {
        if (['ROTATED_270', 'ROTATED_90'].includes(orientation)) {
          height = size.z;
          width = size.x;
        } else if (['NORMAL', 'ROTATED_180'].includes(orientation)) {
          height = size.x;
          width = size.z;
        }
      }

      sizeArray = [width, height, thickness];
    } else if (['VAN-NGANG'].some(item => mesh.name.includes(item))) {
      const height = size.y;
      const width = Math.max(size.x, size.z);
      const thickness = Math.min(size.x, size.z);
      sizeArray = [width, height, thickness];
    } else {
      let width, height;
      if (
        ['CHAN', 'XUONG', 'NEP', 'BRACE', 'HAU-NGANG'].some(item =>
          mesh.name.includes(item)
        ) ||
        (['HAU'].some(item => mesh.name.includes(item)) &&
          moduleType.includes('tv'))
      ) {
        width = Math.max(size.x, size.z);
        height = size.y;
      } else if (['DOOR'].some(item => mesh.name.includes(item))) {
        if (mesh.userData?.drawerUuid || mesh.parent?.userData?.drawerUuid) {
          height = size.y;
          width = Math.max(size.x, size.z);
        } else {
          width = size.y;
          height = Math.max(size.x, size.z);
        }
      } else if (
        ['MAT_TRUOC', 'MAT_SAU', 'MAT_TRAI', 'MAT_PHAI'].some(item =>
          mesh.name.includes(item)
        )
      ) {
        height = size.y;
        width = Math.max(size.x, size.z);
      } else {
        width = size.y;
        height = Math.max(size.x, size.z);
      }
      const thickness = Math.min(size.x, size.z);
      sizeArray = [width, height, thickness];
    }

    // Kiểm tra các trường hợp đặc biệt trước khi dàn ván
    // Chi tiết tấm Hậu (HAU) có khả năng quá khổ sẽ được tách thành nhiều chi tiết nhỏ
    // Chi tiết Đợt kệ (DOTKE) sẽ được chia đôi chiều dày (tính dán cạnh 34mm cho chi tiết này)
    // Các chi tiết có tên ["RAY", "MAT-DA", "VACH-BEP"] không dàn ván
    // Các chi tiết có type [InsideType.CLOTHES_HANGER] không dàn ván

    // Tích hợp tính chu vi chi tiết dán cạnh và diện tích sơn
    if (
      ['GROUP_TOP', 'GROUP_EDGE', 'GROUP_LAST', 'CABINET_COVER'].some(item =>
        mesh.userData.name?.includes(item)
      )
    ) {
      if (mesh.userData.useAcrylic) {
        const area = sizeArray[0] * sizeArray[1];
        const price = texture.texturePrice?.['0.017'];
        // let cost = area * price;
        // cost = this.calculateWithProfitMargin({
        //   basePrice: cost,
        //   supplier: this.supplierName,
        // });
        // this.costAcrylicCBTrim.push({
        //   area,
        //   price,
        //   name: mesh.userData.name,
        //   cost,
        // });

        this.materialsData.push({
          type: 'acrylicCabinetTrims',
          quantity: area,
          customPrice: price,
          id: texture.textureId,
          name: `${mesh.userData.textureCode} - ${0.017}mm - ${mesh.userData.supplier?.materialType}`,
          unit: 'm2',
        });
      } else {
        let width = sizeArray[0];
        while (width > this.BOARD_WIDTH) {
          this.createPart(
            [this.BOARD_WIDTH, sizeArray[1], sizeArray[2]],
            texture,
            mesh
          );
          width -= this.BOARD_WIDTH;
        }
        if (width > 0) {
          this.createPart([width, sizeArray[1], sizeArray[2]], texture, mesh);
        }
      }
    } else if (
      ['VAT-GIUONG', 'FGR_H', 'FLW_H', 'SLW_H', 'FLW_V', 'SDW_V'].some(item =>
        mesh.name.includes(item)
      )
    ) {
      if (!lessOrEqual(roundTo(sizeArray[2], 5), this.THICKNESS_17)) {
        sizeArray[2] = this.THICKNESS_17;
        this.createPart(sizeArray, texture, mesh);
        this.createPart(sizeArray, texture, mesh);
      } else {
        this.createPart(sizeArray, texture, mesh);
      }
    } else if (
      ['HAU'].some(item => mesh.name.includes(item)) &&
      !['tv'].some(item => moduleType.includes(item))
    ) {
      const backPanelSizes = mesh.userData.backPanelSizes;
      let [width, height, thickness] = sizeArray;
      if (backPanelSizes?.length > 1) {
        backPanelSizes.forEach(size => {
          height = Math.max(size.z, size.x);
          width = size.y;
          thickness = Math.min(size.x, size.z);

          if (texture.no_grain) {
            this.createPart(
              [width, height, thickness].sort((a, b) => b - a),
              texture,
              mesh
            );
          } else {
            this.createPart([width, height, thickness], texture, mesh);
          }
        });
      } else {
        if (texture.no_grain) {
          sizeArray.sort((a, b) => b - a);
          this.createPart(sizeArray, texture, mesh);
        } else {
          this.createPart(sizeArray, texture, mesh);
        }
      }
      this.materialsData.forEach(item => {
        if (item.type === 'edgeBanding' && item.subtype === 'normal') {
          item.quantity += 2 * (size.x + size.y);
        }
      });
      this.laborsData.forEach(item => {
        if (item.type === 'edgeBanding' && item.subtype === 'normal') {
          item.quantity += 2 * (size.x + size.y);
        }
      });
    } else if (['DOTKE'].some(item => mesh.name.includes(item))) {
      //Đợt 34 thì x2 dàn ván
      if (sizeArray[2] > this.THICKNESS_17) {
        sizeArray[2] = sizeArray[2] / 2;
        this.createPart(sizeArray, texture, mesh);
        this.createPart(sizeArray, texture, mesh);

        this.materialsData.forEach(item => {
          if (item.type === 'edgeBanding' && item.subtype === 'diff') {
            item.quantity += 2 * (sizeArray[0] + sizeArray[1]);
          }
        });
        this.laborsData.forEach(item => {
          if (item.type === 'edgeBanding' && item.subtype === 'diff') {
            item.quantity += 2 * (sizeArray[0] + sizeArray[1]);
          }
        });
      } else {
        // this.createPart(sizeArray, texture, mesh);
        this.createPart(sizeArray, texture, mesh);
        this.materialsData.forEach(item => {
          if (item.type === 'edgeBanding' && item.subtype === 'normal') {
            item.quantity += 2 * (sizeArray[0] + sizeArray[1]);
          }
        });
        this.laborsData.forEach(item => {
          if (item.type === 'edgeBanding' && item.subtype === 'normal') {
            item.quantity += 2 * (sizeArray[0] + sizeArray[1]);
          }
        });
      }
    } else {
      if (
        mesh.userData?.isHelperBox ||
        ['RAY', 'MAT-DA', 'VACH-BEP'].some(item => mesh.name.includes(item)) ||
        [
          InsideType.CLOTHES_HANGER,
          InsideType.DOOR_TEMPLATE,
          InsideType.MESH_TEMPLATE,
        ].some(item => item === mesh.userData.type)
      ) {
        return;
      }

      this.createPart(sizeArray, texture, mesh);
      if (mesh.parent.userData.type === InsideType.DOOR) {
        if (mesh.parent.userData.beveled) {
          this.materialsData.forEach(item => {
            if (item.type === 'edgeBanding' && item.subtype === 'bevel') {
              item.quantity += sizeArray[1];
            }
            if (item.type === 'edgeBanding' && item.subtype === 'normal') {
              item.quantity += 2 * (sizeArray[0] + sizeArray[1]) - sizeArray[1];
            }
          });
          this.laborsData.forEach(item => {
            if (item.type === 'edgeBanding' && item.subtype === 'bevel') {
              item.quantity += sizeArray[1];
            }
            if (item.type === 'edgeBanding' && item.subtype === 'normal') {
              item.quantity += 2 * (sizeArray[0] + sizeArray[1]) - sizeArray[1];
            }
          });
        } else {
          this.materialsData.forEach(item => {
            if (item.type === 'edgeBanding' && item.subtype === 'normal') {
              item.quantity += 2 * (sizeArray[0] + sizeArray[1]);
            }
          });
          this.laborsData.forEach(item => {
            if (item.type === 'edgeBanding' && item.subtype === 'normal') {
              item.quantity += 2 * (sizeArray[0] + sizeArray[1]);
            }
          });
        }
      } else {
        this.materialsData.forEach(item => {
          if (item.type === 'edgeBanding' && item.subtype === 'normal') {
            item.quantity += 2 * (sizeArray[0] + sizeArray[1]);
          }
        });
        this.laborsData.forEach(item => {
          if (item.type === 'edgeBanding' && item.subtype === 'normal') {
            item.quantity += 2 * (sizeArray[0] + sizeArray[1]);
          }
        });
      }
    }
  };

  createPart = (sizeArray, texture, mesh) => {
    const [width, height, thickness] = sizeArray;
    let thicknessType;

    if (
      !(
        lessOrEqual(width, this.BOARD_WIDTH) &&
        lessOrEqual(height, this.BOARD_HEIGHT)
      )
    ) {
      this.oversizeModule.push(mesh.parent);
    }
    // Determine thickness type
    if (nearlyEqual(thickness, this.THICKNESS_17, 0.001)) {
      thicknessType = this.THICKNESS_17;
    } else if (nearlyEqual(thickness, this.THICKNESS_08, 0.001)) {
      thicknessType = this.THICKNESS_08;
    } else if (thickness === 0) {
      return;
    } else {
      // throw new Error(`${mesh.name} không xác định độ dày!`);
      return;
    }

    const newPart = new ItemRetangle({
      id: mesh.uuid,
      name: mesh.name ?? mesh.userData.name,
      width,
      height,
      thickness,
      material: texture.material,
      beveled: mesh.userData?.beveled,
      canRotate: texture.no_grain !== false,
      special: texture.special,
    });

    // Process nếu có material name và thickness type
    if (thicknessType) {
      // Tìm part group existing
      const existingPart = this.parts.find(
        item =>
          item.texture.textureId === texture.textureId &&
          item.thickness === thicknessType &&
          item.texture.supplier?.materialType ===
            mesh.userData.supplier?.materialType
      );

      if (existingPart) {
        existingPart.parts.push(newPart);
      } else {
        const partGroup = {
          texture: {
            ...texture,
            texturePrice: texture.texturePrice?.[thicknessType] ?? 0,
          },
          thickness: thicknessType,
          parts: [newPart],
        };
        this.parts.push(partGroup);
      }
      if (!texture.textureId || !mesh.userData.texturePrice) {
        this.noTexture = true;
      }
    }

    return newPart;
  };

  // FIXED: MaxRectsPacker yêu cầu objects có properties width, height
  preparePartsForPacking = parts => {
    return parts
      .map(
        part =>
          new ItemRetangle({
            ...part,
            // MaxRectsPacker cần width và height properties
            width: part.width * 1000,
            height: part.height * 1000,
            // Thêm data gốc để reference
            originalPart: part,
            id: part.id || part.geomName,
          })
      )
      .sort((a, b) => {
        // Sắp xếp theo diện tích giảm dần
        return b.width * b.height - a.width * a.height;
      });
  };

  getTotalValue = value => {
    if (value) {
      if (typeof value === 'number') return value;
      if (typeof value === 'object') {
        return value.total;
      }
    }
    return 0;
  };

  estimateBoardsNeeded = ({
    modules,
    id = 'estimated-cost',
    isFinal = false,
  }) => {
    closeNotification('nesting-controller-error');
    this.clearData();

    try {
      this.disassemblyDoorAndHinge({ modules });
      this.disassemblyAccessoryAndEquipment({ modules });
      this.disassemblyStoneGlass({
        scene: this.cabinetManager.sceneManager.scene,
      });
      this.disassemblyProduct({ modules });
      this.disassemblyPart({ modules });

      // FIXED [C3]: Removed undefined mutations on this.lightSwitches/this.ledDrivers
      // LED switch/driver counting is already handled in disassemblyAccessoryAndEquipment
      // and disassemblyStoneGlass via this.accessoriesData

      const results = [];

      clearVisual(id + '-container');
      this.virtualize(id + '-container');

      this.parts?.forEach(partGroup => {
        const packedParts = this.preparePartsForPacking(partGroup.parts);

        const packer = new MaxRectsPacker(2440, 1220, {
          spacing: 6.8, // 5mm giữa các items
          edgeSpacing: 0, // 10mm từ viền sheet
          allowRotation: true,
        });

        packer.addItems(packedParts);

        packer.pack();

        // Lấy kết quả chi tiết
        const result = packer.getPackingResult();

        packer.visualize(
          id + '-container',
          {
            scale: 1.2,
            showLabels: true,
            showStats: true,
            colorMode: 'auto',
          },
          `${partGroup.texture?.textureCode ?? '--'} / ${partGroup.texture?.supplier?.materialType} / ${partGroup.texture?.texturePrice?.toLocaleString()}` +
            ' đ / ' +
            partGroup.thickness
        );

        results.push({
          ...result,
          texture: partGroup.texture,
          thickness: partGroup.thickness,
        });
      });

      if (this.oversizeModule.length) {
        // message.warning("Kích thước ván lớn quá khổ!");
        this.oversizeModule.forEach(module => {
          this.cabinetManager.sceneManager.handleDrawBorderErrorMesh(module);
        });
        openNotification({
          key: 'over-size-board',
          icon: <Icon.ICWarning />,
          iconColor: '#F97D16',
          title: i18n.t('Exceeds size limit'),
          description: i18n.t(
            'The cabinet frame width exceeds the production board size of 1220 mm; you need to add a vertical splice for this frame size.'
          ),
          placement: 'bottomRight',
        });
      } else {
        closeNotification('over-size-board');
        this.cabinetManager.sceneManager.removeBorderErrorMesh();
        this.cabinetManager.sceneManager.errorModule = [];
      }

      if (!this.noTexture) {
        closeNotification('no-texture-warning');
      }
      if (!this.noGlass) {
        closeNotification('no-glass-warning');
      }
      if (!this.noAlum) {
        closeNotification('no-alum-warning');
      }

      // kiểm tra ván được được dàn hết chưa
      const unpackedName = [];
      results.forEach(item => {
        if (item.unpackedItems.length > 0) {
          // console.log(item.unpackedItems);
          item.unpackedItems.forEach(item => {
            unpackedName.push(item.name);
          });
        }
      });
      if (unpackedName.length) {
        throw new Error(
          i18n.t('Unable to nest boards') + ': ' + unpackedName.join(',')
        );
      }

      this.boards = results.map(rs => {
        // Tính số tấm ván có diện tích sử dụng < 60%
        const optimizedBins =
          rs.texture?.supplier?.materialType?.toLowerCase() !== 'plastic'
            ? rs.bins
                .filter(bin => {
                  const usagePercent = bin.usedArea / bin.totalArea;
                  return !greaterOrEqual(usagePercent, 0.6);
                  // &&
                  // rs.texture.special === true &&
                  // !this.cabinetManager?.sceneManager?.skipSpecialTexture
                })
                .map(bin => {
                  const optimizedBins = bin.usedArea / bin.totalArea;
                  return { ...bin, usagePercent: optimizedBins };
                })
            : [];
        return {
          count: rs.totalBins - optimizedBins.length,
          countOptimized: optimizedBins.length,
          optimizedBins,
          texture: rs.texture,
          thickness: rs.thickness,
        };
      });

      const countBoards =
        this.boards.reduce((prev, curr) => {
          return prev + curr.count + curr.countOptimized;
        }, 0) ?? 0;

      this.laborsData.forEach(labor => {
        if (['design', 'cnc', 'packing'].some(type => labor.type === type)) {
          labor.quantity += countBoards;
        }
      });

      this.boards.forEach(board => {
        board.optimizedBins.forEach(bin => {
          this.materialsData.push({
            type: 'boards',
            id: board.texture?.textureId,
            textureType: board.texture?.supplier?.materialType,
            thickness: board.thickness,
            quantity: roundTo(bin.usagePercent, 2),
            customPrice: board.texture.texturePrice,
            name: `${board.texture.textureCode} - ${board.thickness}mm - ${board.texture.supplier?.materialType}`,
            unit: 'sheet',
          });
        });
        if (board.count) {
          this.materialsData.push({
            type: 'boards',
            id: board.texture?.textureId,
            textureType: board.texture?.supplier?.materialType,
            thickness: board.thickness,
            quantity: board.count,
            customPrice: board.texture.texturePrice,
            name: `${board.texture.textureCode} - ${board.thickness}mm - ${board.texture.supplier?.materialType}`,
            unit: 'sheet',
          });
        }
      }, 0) ?? 0;

      this.calculateCostDoor({ modules });
      this.calculateCostMaterial();
      this.calculateCostComponent();
      this.calculateCostAccessory();
      this.calculateCostLabor();
      this.calculateCostSpecial();

      this.debug();
      if (this.noTexture || this.noGlass || this.oversizeModule.length) {
        this.parts = [];
      }

      if (this.pricingAdapterUS.getAggregatedSaleTotals().grand) {
        this.calculateCostImportDuty({
          grandSale: this.pricingAdapterUS.getAggregatedSaleTotals().grand,
        });
        this.calculateCostShippingForeign();
        this.calculateCostGroundTrip();
      }

      const detailSaleTotalsVN =
        this.pricingAdapterVN.getDetailedBreakdownSale();
      const detailSaleTotalsUS =
        this.pricingAdapterUS.getDetailedBreakdownSale();

      const aggregatedTotalsVN = this.pricingAdapterVN.getAggregatedTotals();
      const aggregatedSaleTotalsVN =
        this.pricingAdapterVN.getAggregatedSaleTotals();
      const aggregatedTotalsUS = this.pricingAdapterUS.getAggregatedTotals();
      const aggregatedSaleTotalsUS =
        this.pricingAdapterUS.getAggregatedSaleTotals();

      const grandSaleVN = aggregatedSaleTotalsVN.grand;
      const grandCostVN = aggregatedTotalsVN.grand;

      let grandSaleUS = aggregatedSaleTotalsUS.grand;
      const grandCostUS = aggregatedTotalsUS.grand;

      const gst = (() => {
        return this.calculateCostGST({ grandSale: grandSaleUS });
      })();

      grandSaleUS += gst;

      const quantityDoor = this.doorsData.reduce(
        (total, door) => total + door.quantity,
        0
      );
      const quantityMaterial = this.materialsData.reduce(
        (total, material) => total + material.quantity,
        0
      );
      const quantityComponent = this.componentsData.reduce(
        (total, component) => total + component.quantity,
        0
      );
      const quantityAccessory = this.accessoriesData.reduce(
        (total, accessory) => total + accessory.quantity,
        0
      );
      const quantityLabor = this.laborsData.reduce(
        (total, labor) => total + labor.quantity,
        0
      );
      const quantitySpecial = this.specialsData.reduce(
        (total, special) => total + special.quantity,
        0
      );

      if (quantityDoor && aggregatedTotalsVN.doors === 0) {
        openNotification({
          key: 'no-door-price-warning',
          icon: <Icon.ICWarning />,
          iconColor: '#F97D16',
          title: i18n.t('No price for doors'),
          description: i18n.t(
            'There are doors in the design but the price is calculated as 0. Please check the door materials and prices.'
          ),
          placement: 'bottomRight',
          closable: true,
        });
        // if (isFinal) {
        //   Sentry.captureMessage('No price for doors', {
        //     level: 'warning',
        //     extra: { quantityDoor, aggregatedTotals: aggregatedTotalsVN },
        //   });
        // }
      } else {
        closeNotification('no-door-price-warning');
      }
      if (quantityMaterial && aggregatedTotalsVN.materials === 0) {
        openNotification({
          key: 'no-material-price-warning',
          icon: <Icon.ICWarning />,
          iconColor: '#F97D16',
          title: i18n.t('No price for materials'),
          description: i18n.t(
            'There are materials in the design but the price is calculated as 0. Please check the material prices.'
          ),
          placement: 'bottomRight',
          closable: true,
        });
        // if (isFinal) {
        //   Sentry.captureMessage('No price for materials', {
        //     level: 'warning',
        //     extra: { quantityMaterial, aggregatedTotals: aggregatedTotalsVN },
        //   });
        // }
      } else {
        closeNotification('no-material-price-warning');
      }

      if (quantityComponent && aggregatedTotalsVN.component === 0) {
        openNotification({
          key: 'no-component-price-warning',
          icon: <Icon.ICWarning />,
          iconColor: '#F97D16',
          title: i18n.t('No price for components'),
          description: i18n.t(
            'There are components in the design but the price is calculated as 0. Please check the component prices.'
          ),
          placement: 'bottomRight',
          closable: true,
        });
        // if (isFinal) {
        //   Sentry.captureMessage('No price for components', {
        //     level: 'warning',
        //     extra: { quantityComponent, aggregatedTotals: aggregatedTotalsVN },
        //   });
        // }
      } else {
        closeNotification('no-component-price-warning');
      }

      if (quantityAccessory && aggregatedTotalsVN.accessory === 0) {
        openNotification({
          key: 'no-accessory-price-warning',
          icon: <Icon.ICWarning />,
          iconColor: '#F97D16',
          title: i18n.t('No price for accessories'),
          description: i18n.t(
            'There are accessories in the design but the price is calculated as 0. Please check the accessory prices.'
          ),
          placement: 'bottomRight',
          closable: true,
        });
        // if (isFinal) {
        //   Sentry.captureMessage('No price for accessories', {
        //     level: 'warning',
        //     extra: { quantityAccessory, aggregatedTotals: aggregatedTotalsVN },
        //   });
        // }
      } else {
        closeNotification('no-accessory-price-warning');
      }

      if (quantityLabor && aggregatedTotalsVN.labor === 0) {
        openNotification({
          key: 'no-labor-price-warning',
          icon: <Icon.ICWarning />,
          iconColor: '#F97D16',
          title: i18n.t('No price for labor'),
          description: i18n.t(
            'There are labor items in the design but the price is calculated as 0. Please check the labor prices.'
          ),
          placement: 'bottomRight',
          closable: true,
        });
        // if (isFinal) {
        //   Sentry.captureMessage('No price for labor', {
        //     level: 'warning',
        //     extra: { quantityLabor, aggregatedTotals: aggregatedTotalsVN },
        //   });
        // }
      } else {
        closeNotification('no-labor-price-warning');
      }

      if (quantitySpecial && aggregatedTotalsVN.special === 0) {
        openNotification({
          key: 'no-special-price-warning',
          icon: <Icon.ICWarning />,
          iconColor: '#F97D16',
          title: i18n.t('No price for special items'),
          description: i18n.t(
            'There are special items in the design but the price is calculated as 0. Please check the special item prices.'
          ),
          placement: 'bottomRight',
          closable: true,
        });
        // if (isFinal) {
        //   Sentry.captureMessage('No price for special items', {
        //     level: 'warning',
        //     extra: { quantitySpecial, aggregatedTotals: aggregatedTotalsVN },
        //   });
        // }
      } else {
        closeNotification('no-special-price-warning');
      }

      return {
        registryCost: {
          vn: this.pricingAdapterVN.getRegistryCost().registry,
          us: this.pricingAdapterUS.getRegistryCost().registry,
        },
        registrySale: {
          vn: this.pricingAdapterVN.getRegistrySale().registry,
          us: this.pricingAdapterUS.getRegistrySale().registry,
        },
        grand: { vn: grandSaleVN, us: grandSaleUS },
        grandCost: { vn: grandCostVN, us: grandSaleUS },
        gst,
        costPersistable: {
          vn: this.pricingAdapterVN.getRegistryCost().toPersistable(),
          us: this.pricingAdapterUS.getRegistryCost().toPersistable(),
        },
        salePersistable: {
          vn: this.pricingAdapterVN.getRegistrySale().toPersistable(),
          us: this.pricingAdapterUS.getRegistrySale().toPersistable(),
        },
        aggregatedTotals: { vn: aggregatedTotalsVN, us: aggregatedTotalsUS },
        aggregatedSaleTotals: {
          vn: aggregatedSaleTotalsVN,
          us: aggregatedSaleTotalsUS,
        },
        total: {
          totalMaterials: {
            costBoards: this.getTotalValue(
              detailSaleTotalsVN.materials?.boards
            ),
          },
        },
        detailSaleTotals: {
          vn: detailSaleTotalsVN,
          us: detailSaleTotalsUS,
        },
        noTexture: this.noTexture,
        noGlass: this.noGlass,
        noAlum: this.noAlum,
        useSpecialTexture: false,
        // useSpecialTexture: this.useSpecialTexture,
        hasOversizeBoard: this.oversizeModule.length > 0,
      };
    } catch (error) {
      // if (isFinal) Sentry.captureException(error);
      openNotification({
        key: 'nesting-controller-error',
        icon: <Icon.ICWarning />,
        iconColor: '#F97D16',
        title: i18n.t('Failed to calculate price'),
        description: error?.message ?? '',
        placement: 'bottomRight',
        closable: true,
      });
      this.clearData();
      return undefined;
    }
  };

  validatePricingResult = ({
    grand,
    grandCost,
    aggregatedTotals,
    aggregatedSaleTotals,
  }) => {
    const errors = [];
    const categories = [
      'doors',
      'materials',
      'component',
      'accessory',
      'labor',
      'special',
      'transport',
    ];
    // Validate grand = sum of aggregatedSaleTotals categories
    const expectedGrand = categories.reduce(
      (sum, key) => sum + (aggregatedSaleTotals[key] || 0),
      0
    );
    if (Math.abs(grand - expectedGrand) > 0.01) {
      errors.push(`grand mismatch: ${grand} vs expected ${expectedGrand}`);
    }

    // Validate grandCost = sum of aggregatedTotals categories
    const expectedGrandCost = categories.reduce(
      (sum, key) => sum + (aggregatedTotals[key] || 0),
      0
    );
    if (Math.abs(grandCost - expectedGrandCost) > 0.01) {
      errors.push(
        `grandCost mismatch: ${grandCost} vs expected ${expectedGrandCost}`
      );
    }

    // Validate sale >= cost (profit margin applied)
    if (grand < grandCost) {
      errors.push(`grand (${grand}) < grandCost (${grandCost})`);
    }

    // Validate no negative values
    if (grand < 0 || grandCost < 0) {
      errors.push('Negative totals detected');
    }

    // Validate all categories exist
    categories.forEach(key => {
      if (typeof aggregatedTotals[key] !== 'number') {
        errors.push(`aggregatedTotals.${key} is not a number`);
      }
      if (typeof aggregatedSaleTotals[key] !== 'number') {
        errors.push(`aggregatedSaleTotals.${key} is not a number`);
      }
    });

    return errors;
  };

  calculateCostDoor = ({ modules }) => {
    this.doorsData.forEach(door => {
      const {
        cost: costVN,
        rule: baseFormula,
        basePrice,
        variables,
      } = this.pricingAdapterVN.calculator.calculateComponentCost({
        type: door.type,
        category: 'doors',
        subtype: door.subtype, // e.g., 'transparentGlass', 'melamine', 'dulux'
        quantity: roundTo(door.quantity, 3),
        unitPrice: door.customPrice,
      });
      const {
        cost: costVNWithMargin,
        rule: baseFormulaWithProfit,
        profit,
      } = this.pricingAdapterVN.calculator.calculateComponentSale({
        type: door.type,
        category: 'doors',
        subtype: door.subtype, // e.g., 'transparentGlass', 'melamine', 'dulux'
        cost: costVN,
      });

      this.pricingAdapterVN.addCost(
        'doors',
        door.type,
        {
          quantity: JSON.stringify(roundTo(door.quantity, 3)),
          unitPrice: JSON.stringify(door.customPrice),
          name: door.name,
          unit: door.unit,
          id: door.id,
          type: door.textureType,
          cost: costVN,
          thickness: door.thickness,
          material: door.material,
          sale: costVNWithMargin,
          baseFormula,
          baseFormulaWithProfit,
          variables,
          basePrice,
          profit,
        },
        {
          cost: costVNWithMargin,
        },
        door.subtype
      );

      // Mở rộng phần tính giá cho tính giá nước ngoài
      const {
        cost: costUS,
        rule: baseFormulaUS,
        basePrice: basePriceUS,
        variables: variablesUS,
      } = this.pricingAdapterUS.calculator.calculateComponentCost({
        type: door.type,
        category: 'doors',
        subtype: door.subtype, // e.g., 'transparentGlass', 'melamine', 'dulux'
        quantity: roundTo(door.quantity, 3),
        unitPrice: door.customPrice,
      });
      const {
        cost: costUSWithMargin,
        rule: baseFormulaWithProfitUS,
        profit: profitUS,
      } = this.pricingAdapterUS.calculator.calculateComponentSale({
        type: door.type,
        category: 'doors',
        subtype: door.subtype, // e.g., 'transparentGlass', 'melamine', 'dulux'
        cost: costUS,
      });

      this.pricingAdapterUS.addCost(
        'doors',
        door.type,
        {
          quantity: JSON.stringify(roundTo(door.quantity, 3)),
          unitPrice: JSON.stringify(door.customPrice),
          name: door.name,
          unit: door.unit,
          id: door.id,
          type: door.textureType,
          cost: costUS,
          thickness: door.thickness,
          material: door.material,
          sale: costUSWithMargin,
          baseFormula: baseFormulaUS,
          baseFormulaWithProfit: baseFormulaWithProfitUS,
          variables: variablesUS,
          basePrice: basePriceUS,
          profit: profitUS,
        },
        {
          cost: costUSWithMargin,
        },
        door.subtype
      );
    });
  };

  calculateCostMaterial = () => {
    this.materialsData.forEach(material => {
      const {
        cost: costVN,
        rule: baseFormula,
        basePrice,
        variables,
      } = this.pricingAdapterVN.calculator.calculateComponentCost({
        type: material.type,
        category: 'materials',
        subtype: material.subtype,
        quantity: roundTo(material.quantity, 3),
        unitPrice: material.customPrice,
      });
      const {
        cost: costVNWithMargin,
        rule: baseFormulaWithProfit,
        profit,
      } = this.pricingAdapterVN.calculator.calculateComponentSale({
        type: material.type,
        category: 'materials',
        subtype: material.subtype,
        cost: costVN,
      });
      this.pricingAdapterVN.addCost(
        'materials',
        material.type,
        {
          cost: costVN,
          quantity: JSON.stringify(roundTo(material.quantity, 3)),
          unitPrice: JSON.stringify(material.customPrice),
          textureId: material.textureId,
          thickness: JSON.stringify(material.thickness),
          name: material.name,
          unit: material.unit,
          sale: costVNWithMargin,
          id: material.id,
          type: material.textureType,
          baseFormula,
          baseFormulaWithProfit,
          variables,
          basePrice,
          profit,
        },
        { cost: costVNWithMargin },
        material.subtype
      );

      // Mở rộng phần tính giá cho tính giá nước ngoài
      const {
        cost: costUS,
        rule: baseFormulaUS,
        basePrice: basePriceUS,
        variables: variablesUS,
      } = this.pricingAdapterUS.calculator.calculateComponentCost({
        type: material.type,
        category: 'materials',
        subtype: material.subtype,
        quantity: roundTo(material.quantity, 3),
        unitPrice: material.customPrice,
      });
      const {
        cost: costUSWithMargin,
        rule: baseFormulaWithProfitUS,
        profit: profitUS,
      } = this.pricingAdapterUS.calculator.calculateComponentSale({
        type: material.type,
        category: 'materials',
        subtype: material.subtype,
        cost: costUS,
      });
      this.pricingAdapterUS.addCost(
        'materials',
        material.type,
        {
          cost: costUS,
          quantity: JSON.stringify(roundTo(material.quantity, 3)),
          unitPrice: JSON.stringify(material.customPrice),
          textureId: material.textureId,
          thickness: JSON.stringify(material.thickness),
          name: material.name,
          unit: material.unit,
          sale: costUSWithMargin,
          id: material.id,
          type: material.textureType,
          baseFormula: baseFormulaUS,
          baseFormulaWithProfit: baseFormulaWithProfitUS,
          variables: variablesUS,
          basePrice: basePriceUS,
          profit: profitUS,
        },
        { cost: costUSWithMargin },
        material.subtype
      );
    });
  };

  calculateCostComponent = () => {
    this.componentsData.forEach(component => {
      const {
        cost: costVN,
        rule: baseFormula,
        basePrice,
        variables,
      } = this.pricingAdapterVN.calculator.calculateComponentCost({
        type: component.type,
        category: 'component',
        quantity: roundTo(component.quantity, 3),
        unitPrice: component.customPrice,
      });
      const {
        cost: costVNWithMargin,
        rule: baseFormulaWithProfit,
        profit,
      } = this.pricingAdapterVN.calculator.calculateComponentSale({
        type: component.type,
        category: 'component',
        subtype: component.subtype,
        cost: costVN,
      });

      this.pricingAdapterVN.addCost(
        'component',
        component.type,
        {
          cost: costVN,
          name: component.name,
          quantity: JSON.stringify(roundTo(component.quantity, 3)),
          unitPrice: JSON.stringify(component.customPrice),
          unit: component.unit,
          sale: costVNWithMargin,
          id: component.id,
          type: component.textureType,
          baseFormula,
          baseFormulaWithProfit,
          variables,
          basePrice,
          profit,
        },
        { cost: costVNWithMargin }
      );

      // Mở rộng phần tính giá cho tính giá nước ngoài
      const {
        cost: costUS,
        rule: baseFormulaUS,
        basePrice: basePriceUS,
        variables: variablesUS,
      } = this.pricingAdapterUS.calculator.calculateComponentCost({
        type: component.type,
        category: 'component',
        quantity: roundTo(component.quantity, 3),
      });
      const {
        cost: costUSWithMargin,
        rule: baseFormulaWithProfitUS,
        profit: profitUS,
      } = this.pricingAdapterUS.calculator.calculateComponentSale({
        type: component.type,
        category: 'component',
        subtype: component.subtype,
        cost: costUS,
      });

      this.pricingAdapterUS.addCost(
        'component',
        component.type,
        {
          cost: costUS,
          sale: costUSWithMargin,
          id: component.id,
          type: component.textureType,
          name: component.name,
          quantity: JSON.stringify(roundTo(component.quantity, 3)),
          unitPrice: JSON.stringify(component.customPrice),
          unit: component.unit,
          thumbnail_url: component.thumbnail_url,
          baseFormula: baseFormulaUS,
          baseFormulaWithProfit: baseFormulaWithProfitUS,
          variables: variablesUS,
          basePrice: basePriceUS,
          profit: profitUS,
        },
        { cost: costUSWithMargin }
      );
    });
  };

  calculateCostAccessory = () => {
    this.accessoriesData.forEach(accessory => {
      const {
        cost: costVN,
        rule: baseFormula,
        basePrice,
        variables,
      } = this.pricingAdapterVN.calculator.calculateComponentCost({
        category: 'accessory',
        quantity: roundTo(accessory.quantity, 3),
        unitPrice: accessory.customPrice,
        subtype: accessory.subtype,
        type: accessory.type,
      });
      const {
        cost: costVNWithMargin,
        rule: baseFormulaWithProfit,
        profit,
      } = this.pricingAdapterVN.calculator.calculateComponentSale({
        type: accessory.type,
        category: 'accessory',
        subtype: accessory.subtype,
        cost: costVN,
      });

      this.pricingAdapterVN.addCost(
        'accessory',
        accessory.type,
        {
          type: accessory.type,
          cost: costVN,
          name: accessory.name,
          quantity: JSON.stringify(roundTo(accessory.quantity, 3)),
          unitPrice: JSON.stringify(accessory.customPrice),
          unit: accessory.unit,
          thumbnail_url: accessory.thumbnail_url,
          sale: costVNWithMargin,
          id: accessory.id,
          baseFormula,
          baseFormulaWithProfit,
          variables,
          basePrice,
          profit,
        },
        { cost: costVNWithMargin },
        accessory.subtype
      );

      // Mở rộng phần tính giá cho tính giá nước ngoài
      const {
        cost: costUS,
        rule: baseFormulaUS,
        basePrice: basePriceUS,
        variables: variablesUS,
      } = this.pricingAdapterUS.calculator.calculateComponentCost({
        category: 'accessory',
        quantity: roundTo(accessory.quantity, 3),
        unitPrice: accessory.customPrice,
        subtype: accessory.subtype,
        type: accessory.type,
      });
      const {
        cost: costUSWithMargin,
        rule: baseFormulaWithProfitUS,
        profit: profitUS,
      } = this.pricingAdapterUS.calculator.calculateComponentSale({
        type: accessory.type,
        category: 'accessory',
        subtype: accessory.subtype,
        cost: costUS,
      });

      this.pricingAdapterUS.addCost(
        'accessory',
        accessory.type,
        {
          type: accessory.type,
          cost: costUS,
          name: accessory.name,
          quantity: JSON.stringify(roundTo(accessory.quantity, 3)),
          unitPrice: JSON.stringify(accessory.customPrice),
          unit: accessory.unit,
          thumbnail_url: accessory.thumbnail_url,
          sale: costUSWithMargin,
          id: accessory.id,
          baseFormula: baseFormulaUS,
          baseFormulaWithProfit: baseFormulaWithProfitUS,
          variables: variablesUS,
          basePrice: basePriceUS,
          profit: profitUS,
        },
        { cost: costUSWithMargin },
        accessory.subtype
      );
    });
  };

  calculateCostLabor = () => {
    this.laborsData.forEach(labor => {
      const {
        cost: costVN,
        rule: baseFormula,
        basePrice,
        variables,
      } = this.pricingAdapterVN.calculator.calculateComponentCost({
        type: labor.type,
        category: 'labor',
        subtype: labor.subtype,
        quantity: roundTo(labor.quantity, 3),
      });
      const {
        cost: costVNWithMargin,
        rule: baseFormulaWithProfit,
        profit,
      } = this.pricingAdapterVN.calculator.calculateComponentSale({
        type: labor.type,
        category: 'labor',
        subtype: labor.subtype,
        cost: costVN,
      });

      this.pricingAdapterVN.addCost(
        'labor',
        labor.type,
        {
          cost: costVN,
          quantity: JSON.stringify(roundTo(labor.quantity, 3)),
          unitPrice: JSON.stringify(labor.customPrice),
          unit: labor.unit,
          sale: costVNWithMargin,
          id: labor.id,
          baseFormula,
          baseFormulaWithProfit,
          variables,
          basePrice,
          profit,
        },
        { cost: costVNWithMargin },
        labor.subtype
      );

      // Mở rộng chức năng tính giá cho tính giá nước ngoài
      const {
        cost: costUS,
        rule: baseFormulaUS,
        basePrice: basePriceUS,
        variables: variablesUS,
      } = this.pricingAdapterUS.calculator.calculateComponentCost({
        type: labor.type,
        category: 'labor',
        subtype: labor.subtype,
        quantity: roundTo(labor.quantity, 3),
      });
      const {
        cost: costUSWithMargin,
        rule: baseFormulaWithProfitUS,
        profit: profitUS,
      } = this.pricingAdapterUS.calculator.calculateComponentSale({
        type: labor.type,
        category: 'labor',
        subtype: labor.subtype,
        cost: costUS,
      });

      this.pricingAdapterUS.addCost(
        'labor',
        labor.type,
        {
          cost: costUS,
          quantity: JSON.stringify(roundTo(labor.quantity, 3)),
          unitPrice: JSON.stringify(labor.customPrice),
          unit: labor.unit,
          sale: costUSWithMargin,
          id: labor.id,
          baseFormula: baseFormulaUS,
          baseFormulaWithProfit: baseFormulaWithProfitUS,
          variables: variablesUS,
          basePrice: basePriceUS,
          profit: profitUS,
        },
        { cost: costUSWithMargin },
        labor.subtype
      );
    });
  };

  calculateCostSpecial = () => {
    this.specialsData.forEach(special => {
      const registryVN = this.pricingAdapterVN.registryCostPrice.getRegistry();
      if (!registryVN.special[special.type])
        registryVN.special[special.type] = {};
      if (!registryVN.special[special.type][special.subtype])
        registryVN.special[special.type][special.subtype] = [];
      const {
        cost: costVN,
        rule: baseFormula,
        basePrice,
        variables,
      } = this.pricingAdapterVN.calculator.calculateComponentCost({
        type: special.type,
        category: 'special',
        subtype: special.subtype,
        quantity: roundTo(special.quantity, 3),
        unitPrice: special.customPrice,
      });

      this.pricingAdapterVN.addCost(
        'special',
        special.type,
        {
          cost: costVN,
          unitPrice: JSON.stringify(special.customPrice),
          quantity: JSON.stringify(roundTo(special.quantity, 3)),
          unit: special.unit,
          thumbnail_url: special.thumbnail_url,
          name: special.name,
          sale: costVN,
          id: special.id,
          baseFormula,
          variables,
          basePrice,
        },
        { cost: costVN },
        special.subtype
      );

      // Mở rộng chức năng tính giá cho tính giá nước ngoài
      const registryUS = this.pricingAdapterUS.registryCostPrice.getRegistry();
      if (!registryUS.special[special.type])
        registryUS.special[special.type] = {};
      if (!registryUS.special[special.type][special.subtype])
        registryUS.special[special.type][special.subtype] = [];
      const {
        cost: costUS,
        rule: baseFormulaUS,
        basePrice: basePriceUS,
        variables: variablesUS,
      } = this.pricingAdapterUS.calculator.calculateComponentCost({
        type: special.type,
        category: 'special',
        subtype: special.subtype,
        quantity: roundTo(special.quantity, 3),
        unitPrice: special.customPrice,
      });

      this.pricingAdapterUS.addCost(
        'special',
        special.type,
        {
          cost: costUS,
          unitPrice: JSON.stringify(special.customPrice),
          quantity: JSON.stringify(roundTo(special.quantity, 3)),
          unit: special.unit,
          thumbnail_url: special.thumbnail_url,
          name: special.name,
          sale: costUS,
          id: special.id,
          baseFormula: baseFormulaUS,
          variables: variablesUS,
          basePrice: basePriceUS,
        },
        { cost: costUS },
        special.subtype
      );
    });
  };

  calculateCostGST = ({ grandSale }) => {
    const cost = this.pricingAdapterUS.calculator.calculateGST({
      grandSale,
    });

    return cost;
  };

  calculateCostImportDuty = ({ grandSale }) => {
    const {
      cost,
      rule: baseFormula,
      basePrice,
      variables,
    } = this.pricingAdapterUS.calculator.calculateComponentCost({
      type: 'importDuty',
      category: 'transport',
      grandSale,
    });

    this.pricingAdapterUS.addCost(
      'transport',
      'importDuty',
      {
        sale: cost,
        baseFormula,
        variables,
        basePrice,
      },
      { cost: cost }
    );
  };

  calculateCostShippingForeign = () => {
    const {
      cost,
      rule: baseFormula,
      basePrice,
      variables,
    } = this.pricingAdapterUS.calculator.calculateComponentCost({
      type: 'shippingFee',
      category: 'transport',
    });

    const {
      cost: costWithMargin,
      rule: baseFormulaWithProfit,
      profit,
    } = this.pricingAdapterUS.calculator.calculateComponentSale({
      type: 'shippingFee',
      category: 'transport',
      cost,
    });

    this.pricingAdapterUS.addCost(
      'transport',
      'shippingFee',
      {
        cost: cost,
        sale: costWithMargin,
        baseFormula,
        baseFormulaWithProfit,
        basePrice,
        profit
      },
      { cost: costWithMargin }
    );
  };

  calculateCostGroundTrip = () => {
    const { cost, rule: baseFormula, basePrice, variables } =
      this.pricingAdapterUS.calculator.calculateComponentCost({
        type: 'groundTripFee',
        category: 'transport',
      });

    const { cost: costWithMargin, rule: baseFormulaWithProfit, profit } =
      this.pricingAdapterUS.calculator.calculateComponentSale({
        type: 'groundTripFee',
        category: 'transport',
        cost,
      });

    this.pricingAdapterUS.addCost(
      'transport',
      'groundTripFee',
      {
        cost: cost,
        sale: costWithMargin,
        baseFormula,
        baseFormulaWithProfit,
        basePrice,
        variables,
        profit
      },
      { cost: costWithMargin }
    );
  };

  // calculateCostShippingForeign = () => {
  //   this.shippingForeignData.forEach(shipping => {
  //     const cost = this.pricingAdapter.calculator.calculateComponentCost({
  //       type: shipping.type,
  //       category: 'transport',
  //       subtype: shipping.subtype,
  //       quantity: roundTo(shipping.quantity, 3),
  //       ...shipping,
  //     });
  //     const costWithMargin =
  //       this.pricingAdapter.calculator.calculateComponentSale({
  //         type: shipping.type,
  //         category: 'transport',
  //         subtype: shipping.subtype,
  //         cost,
  //       });

  //     this.pricingAdapter.addCost(
  //       'transport',
  //       shipping.type,
  //       {
  //         cost: cost,
  //         quantity: JSON.stringify(roundTo(shipping.quantity, 3)),
  //         unitPrice: JSON.stringify(shipping.customPrice),
  //         unit: shipping.unit,
  //         sale: costWithMargin,
  //         id: shipping.id,
  //       },
  //       { cost: costWithMargin ?? cost },
  //       shipping.subtype
  //     );
  //   });
  // };

  debug = () => {
    // console.clear();
    // console.log('=== NestingController Debug ===');
    // if (process.env.NODE_ENV === 'development') {
    //   console.log(this);
    // }
    // console.log(this.pricingAdapter.getRegistryCost().toJSON());
    // console.log(this.pricingAdapter.getRegistrySale().toJSON());
    // console.log(this.pricingAdapter.getAggregatedTotals());
    // console.log(this.pricingAdapter.getDetailedBreakdownSale());
  };
}

export default NestingController;
